import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCompanyLicense } from "../../api/keyApi";

export const fetchCompanyLicense = createAsyncThunk(
  "license/fetch",
  async (_, thunkAPI) => {
    try {
      const companyUuid = localStorage.getItem("company_uuid");
      const data = await getCompanyLicense(companyUuid);
      if (!data.success) {
        return thunkAPI.rejectWithValue("發生錯誤，請稍後再試");
      }

      return data.license;
    } catch (error) {
      if (error.__handled) return;
      return thunkAPI.rejectWithValue("發生錯誤，請稍後再試");
    }
  }
);

const licenseSlice = createSlice({
  name: "license",
  initialState: {
    data: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCompanyLicense.fulfilled, (state, action) => {
      state.data = action.payload;
    });
  },
});

export default licenseSlice.reducer;
